import { useEffect } from 'react';

import { AnchorLink } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';

import { getAppConfig } from '../utilities';
import * as analyticsConst from '../utilities/constants';
import MaintenanceIcon from './assets/icon';

import './styles/index.css';

function Maintenance(props) {
  const {
    config: { toUrl, btnLabel, heading, description }
  } = props;

  useEffect(() => {
    const analyticsData = {
      description: analyticsConst.MAINTENANCE_DESCRIPTION,
      event: analyticsConst.MAINTENANCE_EVENT,
      page: {
        pageName: analyticsConst.MAINTENANCE_PAGE_NAME
      },
      experience: {
        experienceCategory: analyticsConst.MAINTENANCE_CATEGORY,
        experienceProduct: analyticsConst.MAINTENANCE_PRODUCT,
        capability: analyticsConst.MAINTENANCE_CAPABILITY
      }
    };
    PubSub.publish(analyticsConst.PAGE_LOAD_EVENT, analyticsData);
  }, []);

  const { path } = getAppConfig('server');

  return (
    <section className="maintenance-container" data-testid="maintenance-container">
      <div className="image-wrapper">
        <MaintenanceIcon size={500} />
      </div>
      <div className="description-wrapper">
        <h1 className="b beta">{heading}</h1>
        <p className="b delta">{description}</p>
      </div>
      <div className="btn-wrapper">
        <AnchorLink href={`${path}${toUrl}`} className="back-button eta b" innerHTML={btnLabel} />
      </div>
    </section>
  );
}

Maintenance.propTypes = {
  config: PropTypes.shape({
    toUrl: PropTypes.string,
    btnLabel: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string
  }).isRequired
};

export default Maintenance;
